export interface ScheduledRecovery {
  id: string;
  plannedDate: string;
  modality: string;
  notes: string;
  linkedRecoveryLogID?: string;
}

export const isScheduledRecoveryLogged = (
  item: Pick<ScheduledRecovery, "linkedRecoveryLogID">,
): boolean => Boolean(item.linkedRecoveryLogID?.trim());
